import { render, staticRenderFns } from "./DocenteTurmaRow.vue?vue&type=template&id=b286fab0&"
import script from "./DocenteTurmaRow.vue?vue&type=script&lang=js&"
export * from "./DocenteTurmaRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports